import { render, staticRenderFns } from "./PengecekanTruckDetails.vue?vue&type=template&id=6d80b982&scoped=true&"
import script from "./PengecekanTruckDetails.vue?vue&type=script&lang=js&"
export * from "./PengecekanTruckDetails.vue?vue&type=script&lang=js&"
import style0 from "./PengecekanTruckDetails.vue?vue&type=style&index=0&id=6d80b982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d80b982",
  null
  
)

export default component.exports